import { EventEmitter, Injectable } from '@angular/core';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket$: WebSocketSubject<any> | undefined;
  public audioDataEmitter: EventEmitter<any> = new EventEmitter();

  constructor() {

  }

  open() {
    this.socket$ = webSocket(environment.websocketUrl);

    this.socket$.subscribe({
      next: (message) => {
        this.handleMessage(message);
      },
      error: () => {
        alert('Error from server contact support')
      }
    });
  }


  sendStartEvent(streamSid: string, callSid: string, lang: string, id: number) {
    if (this.socket$) {
      const startMessage = {
        event: 'start',
        streamSid: streamSid,
        start: {
          callSid: callSid,
          customParameters: {
            lang: lang,
            id: id,
            caller: "web"
          }
        }
      };
      this.socket$.next(startMessage);
    }

  }

  sendMediaEvent(streamSid: string, payload: string) {
    if (this.socket$) {
      const mediaMessage = {
        event: 'media',
        streamSid: streamSid,
        media: {
          payload: payload
        }
      };
      this.socket$.next(mediaMessage);
    }
  }

  sendStopEvent(streamSid: string) {
    if (this.socket$) {
      const stopMessage = {
        event: 'stop',
        streamSid: streamSid
      };
      this.socket$.next(stopMessage);
    }
  }

  sendMarkEvent(streamSid: string) {
    if (this.socket$) {
      const stopMessage = {
        event: 'mark',
        streamSid: streamSid
      };
      this.socket$.next(stopMessage);
    }
  }

  handleMessage(message: any) {
    this.audioDataEmitter.emit(message);
  }

  close() {
    if (this.socket$) {
      this.socket$.complete();
    }
  }
}
